/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Indexnow_Key_InvalidInputs */

const en_admin_indexnow_key_invalid = /** @type {(inputs: Admin_Indexnow_Key_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8-128 characters: letters, numbers or dashes`)
};

/**
* | output |
* | --- |
* | "8-128 characters: letters, numbers or dashes" |
*
* @param {Admin_Indexnow_Key_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_indexnow_key_invalid = /** @type {((inputs?: Admin_Indexnow_Key_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Indexnow_Key_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_indexnow_key_invalid(inputs)
});
export { admin_indexnow_key_invalid as "admin.indexnow.key_invalid" }